import type { ModuleCardLayout } from './ModuleGrid';

export const FULL_ROW: ModuleCardLayout = {
  gridSize: { xs: 12, sm: 12, md: 12 },
  padding: 2,
  gap: 2,
  iconSize: { xs: 36, sm: 48 },
};

export const STACKED_ON_MOBILE: ModuleCardLayout = {
  ...FULL_ROW,
  gridSize: { xs: 12, sm: 6, md: 6 },
};

export const HALF_ROW: ModuleCardLayout = {
  gridSize: { xs: 6, sm: 6, md: 6 },
  padding: { xs: 0.5, sm: 2 },
  gap: { xs: 1, sm: 2 },
  iconSize: { xs: 36, sm: 48 },
  titleFontSize: { xs: '1rem', sm: '1.5rem' },
  descriptionFontSize: { xs: '0.75rem', sm: '0.875rem' },
};
